import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { GenericRouteEvent } from 'src/app/types/normalize/generic-route-event.model';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  templateUrl: './group-perform.dialog.html',
  styleUrls: ['./group-perform.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonicModule, NgClass, TranslatePipe],
})
export class GroupPerformDialog implements AfterViewInit, OnDestroy, OnChanges {
  private readonly modalController = inject(ModalController);

  @ViewChild('list') listRef: ElementRef<HTMLUListElement>;
  private readonly mutationsConfig = { childList: true };
  private readonly mutationObserver = new MutationObserver((mutationList, observer) => {
    const listItemCount = this.listRef.nativeElement.querySelectorAll('li')?.length;
    if (!listItemCount) {
      this.close();
    }
  });

  public routeEvents: GenericRouteEvent[] = [];
  public submitting = false;

  ngAfterViewInit(): void {
    this.mutationObserver.observe(this.listRef.nativeElement, this.mutationsConfig);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.routeEvents && !this.routeEvents.filter(e => !e.completed)?.length) {
      this.close();
    }
  }

  public close(): Promise<boolean> {
    return this.modalController.dismiss(null, '', 'groupPerformDialog');
  }

  ngOnDestroy(): void {
    this.mutationObserver.disconnect();
  }
}
